import React, { useState } from 'react';
import productApi from '../../../../services/productApi';
import { exportToExcel, formatDateForFilename } from '../../../../utils/excelExport';
import { useToast } from '../../../../contexts/ToastContext';
import './CsvImportExport.css';

const CsvImportExport = () => {
  const [exportBusy, setExportBusy] = useState(false);
  const [error, setError] = useState('');
  const { showSuccess, showError } = useToast();

  const handleExport = async () => {
    if (exportBusy) return;
    
    setExportBusy(true);
    setError('');
    
    try {
      // Define the batch size for each API call
      const batchSize = 1000;
      let allProducts = [];
      let hasMore = true;
      let skip = 0;
      
      // Get current filter state for active_only and flavor
      const urlParams = new URLSearchParams(window.location.search);
      const activeOnly = urlParams.get('active_only') === 'true';
      const flavorFilter = urlParams.get('flavor') || '';
      
      showSuccess('Starting export, please wait...');
      
      // Fetch all products in batches
      while (hasMore) {
        const response = await productApi.list({
          skip,
          limit: batchSize,
          active_only: activeOnly,
          flavor: flavorFilter
        });
        
        const { items, total } = response;
        
        if (items && items.length > 0) {
          allProducts = [...allProducts, ...items];
          skip += items.length;
          
          // Check if we've fetched all products
          hasMore = allProducts.length < total;
        } else {
          hasMore = false;
        }
      }
      
      // Define column headers in the desired order
      const headers = [
        'flavor',
        'coffee_cost',
        'ingredient_cost',
        'can_cost',
        'packing_cost',
        'total_cogs',
        'wholesale_price',
        'retail_price',
        'wholesale_margin',
        'retail_margin',
        'total_wholesale_volume',
        'total_wholesale_revenue',
        'total_wholesale_profit',
        'coffee_spend',
        'ingredient_spend',
        'is_active',
        'notes',
        'created_at',
        'updatedAt',
        'currentStock',
        'minThreshold',
        'maxCapacity'
      ];
      
      // Generate filename with current date
      const filename = `production-dashboard-${formatDateForFilename()}.csv`;
      
      // Export data to Excel/CSV
      const success = exportToExcel(allProducts, filename, headers);
      
      if (success) {
        showSuccess(`Successfully exported ${allProducts.length} products`);
      } else {
        showError('Export failed');
      }
    } catch (err) {
      console.error('Export error:', err);
      showError(err?.message || 'Failed to export data');
      setError(err?.message || 'Failed to export data');
    } finally {
      setExportBusy(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', gap: 8 }}>
      <button onClick={handleExport} disabled={exportBusy} className="export-button">
        {exportBusy ? (
          <>
            <span className="inline-loader"></span> Exporting...
          </>
        ) : (
          'Export CSV'
        )}
      </button>
      {error && <span style={{ color: '#b91c1c' }}>{error}</span>}
    </div>
  );
};

export default CsvImportExport;